/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PortfolioItemPicture } from './';
import {
    PortfolioItemPictureFromJSON,
    PortfolioItemPictureFromJSONTyped,
    PortfolioItemPictureToJSON,
} from './';

/**
 * 
 * @export
 * @interface PortfolioItemResponse
 */
export interface PortfolioItemResponse {
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemResponse
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioItemResponse
     */
    index: number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemResponse
     */
    type: PortfolioItemResponseTypeEnum;
    /**
     * 
     * @type {PortfolioItemPicture}
     * @memberof PortfolioItemResponse
     */
    picture: PortfolioItemPicture;
}


/**
 * @export
 */
export const PortfolioItemResponseTypeEnum = {
    Video: 'VIDEO',
    Photo: 'PHOTO'
} as const;
export type PortfolioItemResponseTypeEnum = typeof PortfolioItemResponseTypeEnum[keyof typeof PortfolioItemResponseTypeEnum];


/**
 * Check if a given object implements the PortfolioItemResponse interface.
 */
export function instanceOfPortfolioItemResponse(value: object): value is PortfolioItemResponse {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('index' in value) || value['index'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('picture' in value) || value['picture'] === undefined) return false;
    return true;
}

export function PortfolioItemResponseFromJSON(json: any): PortfolioItemResponse {
    return PortfolioItemResponseFromJSONTyped(json, false);
}

export function PortfolioItemResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioItemResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'index': json['index'],
        'type': json['type'],
        'picture': PortfolioItemPictureFromJSON(json['picture']),
    };
}

export function PortfolioItemResponseToJSON(value?: PortfolioItemResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'title': value['title'],
        'index': value['index'],
        'type': value['type'],
        'picture': PortfolioItemPictureToJSON(value['picture']),
    };
}

